import React from 'react';

const EyeBrandingStrippedSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='14'
      viewBox='0 0 17 14'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d='M8.75 1.5C3.97727 1.5 1.25 6.75 1.25 6.75C1.25 6.75 3.97727 12 8.75 12C13.5227 12 16.25 6.75 16.25 6.75C16.25 6.75 13.5227 1.5 8.75 1.5Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.75 9C9.99268 9 11 7.99268 11 6.75C11 5.50733 9.99268 4.5 8.75 4.5C7.50732 4.5 6.5 5.50733 6.5 6.75C6.5 7.99268 7.50732 9 8.75 9Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <line
        x1='15'
        y1='0.957107'
        x2='2.95711'
        y2='13'
        stroke={color}
        strokeLinecap='round'
      />
    </svg>
  );
};

export default EyeBrandingStrippedSVG;
